// extracted by mini-css-extract-plugin
export default {"hsSubNavigation":"SecondaryNavigation_hsSubNavigation__3mIHm","active":"SecondaryNavigation_active__e0ptx","show":"SecondaryNavigation_show__GorRi"};